import CheckIcon from '@atlaskit/icon/core/migration/check-mark--check';
import { ButtonItem } from '@atlaskit/menu';
import { Inline, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { messages } from '@databases/intl/messages';
import { DatabaseField } from '@databases/types/database';
import { DatabaseCalculationType } from '@databases/types/database/view';
import { getFieldCalculationType } from '@databases/utils/database/utils';
import React from 'react';
import { useIntl } from 'react-intl-next';

import { DatabaseCalculationLabel } from './DatabaseCalculationLabel';
import { getCalculationOptionsForFieldType } from './quickCalcUtils';

interface QuickCalcOptionProps {
  field: DatabaseField;
  handleOnClick: (databaseCalculationType?: DatabaseCalculationType) => void;
  calculations?: Record<string, DatabaseCalculationType>;
}
export const QuickCalcOptions: React.FC<QuickCalcOptionProps> = ({
  field,
  handleOnClick,
  calculations,
}) => {
  const currentCalculationType = getFieldCalculationType(field.id, calculations);
  const { formatMessage } = useIntl();

  const checkIcon = (
    <CheckIcon
      label={formatMessage(messages['quick.calculations.check-icon'])}
      LEGACY_size="medium"
      spacing="spacious"
      color={token('color.text.brand')}
    />
  );
  const items = getCalculationOptionsForFieldType(field.type).map((calculationType) => {
    return (
      <ButtonItem
        key={calculationType}
        iconBefore={
          currentCalculationType ? (
            <Inline
              xcss={xcss({
                visibility:
                  currentCalculationType === calculationType ? 'visible' : 'hidden',
              })}
            >
              {checkIcon}
            </Inline>
          ) : null
        }
        onClick={() => {
          handleOnClick(calculationType);
        }}
      >
        <DatabaseCalculationLabel type={calculationType} />
      </ButtonItem>
    );
  });

  if (currentCalculationType) {
    const NoneOption = (
      <ButtonItem
        key={'none'}
        iconBefore={
          <Inline
            xcss={xcss({
              visibility: currentCalculationType ? 'hidden' : 'visible',
            })}
          >
            {checkIcon}
          </Inline>
        }
        onClick={() => {
          handleOnClick(undefined);
        }}
      >
        {formatMessage(messages['quick.calculations.calculation-type-none'])}
      </ButtonItem>
    );

    return [NoneOption, ...items];
  } else {
    return items;
  }
};
